// =============================================
// WASSLA BRAND - Single Source of Truth
// =============================================

export const BRAND = {
  name: "Wassla",
  nameAr: "وصلة",
  slogan: {
    en: "One Link. Many Opportunities.",
    ar: "رابط واحد، فرص متعددة",
  },
};

// Minimalist variant for compact spaces
export const BRAND_MINI = {
  slogan: {
    en: "Local growth. Trusted.",
    ar: "نمو محلي. بثقة.",
  },
};

// Helper to get localized slogan
export function getSlogan(lang = 'en') {
  const isArabic = lang?.startsWith('ar');
  return isArabic ? BRAND.slogan.ar : BRAND.slogan.en;
}

// Helper to get localized brand name
export function getBrandName(lang = 'en') {
  const isArabic = lang?.startsWith('ar');
  return isArabic ? BRAND.nameAr : BRAND.name;
}

export default BRAND;
